module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAPklEQVRIS+3SsQkAMAwDwWj/oeUBXDwpQpp3axvBobTteTgxgHQXUZLQ083eANSSSCIUwANbJBEK4IEt+k80yA9gCbXiBIoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrows_lt.png
// module id = yMtG
// module chunks = 0